import type { StaticLandingPage } from '../../../content';

export const qmLandingPage = {
  slug: 'aca-de-qm',
  archetype: 'broad-match',
  body: [
    {
      _uid: 'qm-de-figma-design',
      component: 'qm_landing_page',
    },
  ],
} satisfies StaticLandingPage;
